const Link = {
  baseStyle: {
    textUnderlineOffset: "4px",
    color: "blue.500",
    textStyle: "body-md",
    fontWeight: "regular",
    _hover: {
      color: "blue.400"
    },
    _dark: {
      _hover: {
        color: "blue.400"
      }
    }
  },
  variants: {
    upsell: {
      color: "purple.500",
      _hover: {
        color: "purple.600"
      },
      _dark: {
        color: "purple.300",
        _hover: {
          color: "purple.200"
        }
      }
    },
    primary: {
      textDecoration: "underline",
      color: "blue.500",
      _hover: {
        color: "blue.400"
      },
      _dark: {
        color: "blue.500",
        _hover: {
          color: "blue.400"
        }
      }
    },
    secondary: {
      color: "text-secondary",
      _hover: {
        color: "text-primary"
      },
      _dark: {
        color: "text-secondary",
        _hover: {
          color: "text-primary"
        }
      }
    },
    tertiary: {
      color: "text-secondary",
      _hover: {
        color: "text-primary"
      },
      _dark: {
        color: "text-secondary",
        _hover: {
          color: "text-primary"
        }
      }
    },
    "inline-primary": {
      textDecoration: "underline",
      color: "text-primary",
      _hover: {
        color: "text-primary",
        opacity: "0.8"
      },
      _dark: {
        _hover: {
          color: "text-primary"
        }
      }
    },
    "inline-secondary": {
      textDecoration: "underline",
      color: "text-secondary",
      _hover: {
        color: "text-secondary",
        opacity: "0.8"
      },
      _dark: {
        _hover: {
          color: "text-secondary"
        }
      }
    },
    "inline-tertiary": {
      textDecoration: "underline",
      color: "text-secondary",
      _hover: {
        color: "text-secondary",
        opacity: "0.8"
      },
      _dark: {
        _hover: {
          color: "text-secondary"
        }
      }
    }
  },
  defaultProps: {
    variant: "primary"
  }
};

export { Link };
